/* Copyright Verge Technologies 2018
 * @file products.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

// Modules
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Query } from 'react-apollo';
import PubSub from 'pubsub-js';
import { PulseLoader } from 'react-spinners';
import PropTypes from 'prop-types';
import qs from 'qs';
// GraphQL
import { PRODUCTS_QUERY } from '../../graphql';

// Components
import ProductCard from '../../components/ProductCard/productCard';
import ProductFilters from '../../components/ProductFilters/productFilters';
import Pagination from '../../components/Pagination/pagination';
import { retrieveFromHash } from '../../common/helper';

const uuidv1 = require('uuid/v1');
class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 15,
      searchParams: {
        keywords: [],
        applications: [],
        brands: [],
        sortBy: '',
      },
    };
  }

  componentDidMount() {
    this.setState({
      ...this.state,
      searchParams: {
        ...this.searchParams,
        keywords: this.props.filter.search !== undefined ? this.props.filter.search.split(/\s+/) : [],
        applications: this.props.applications,
        brands: this.props.brands,
      },
    });
  }

  componentWillReceiveProps(props) {
    let brands = [];
    let applications = [];
    if (props.isBrand) {
      brands = retrieveFromHash()
    } else {
      applications = retrieveFromHash()
    }

    this.setState({
      ...this.state,
      searchParams: {
        ...this.searchParams,
        keywords: this.props.filter.search !== undefined ? this.props.filter.search.split(/\s+/) : [],
        applications: applications,
        brands: brands,
        sortBy: props.sortBy,
      },
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      const queryValue = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
      if (queryValue.search) {
        this.setState({
          ...this.state,
          searchParams: {
            keywords: queryValue !== undefined ? queryValue.search.split(/\s+/) : []
          },
        });
      }

    }
  }


  // Add an item to your favourites list
  favouriteItem = (event, itemId) => {
    event.preventDefault();
    const favourites = JSON.parse(localStorage.getItem('SEPARATIONS_FAVOURITES'));
    // Check if the item already exists in favourites
    if (
      favourites.some((favourite) => {
        return favourite.id === itemId;
      })
    ) {
      return;
    }
    favourites.push({ id: itemId, quantity: 1 });
    localStorage.setItem('SEPARATIONS_FAVOURITES', JSON.stringify(favourites));
    // Publish the event for the listeners
    PubSub.publish('LOCAL_UPDATE');
  };

  render() {
    let checkbrands = [];
    let checkApplications = [];
    if (this.props.isBrand) {
      checkbrands = retrieveFromHash();
    } else {
      checkApplications = retrieveFromHash();
    }
    return (
      <div className="product-container">
        <ProductFilters
          isBrand={this.props.isBrand}
          filters={this.state.searchParams}
          id={this.props.id}
          updateBrand={this.props.updateBrand}
          updateApplication={this.props.updateApplication}
          checkedBrands={checkbrands}
          checkedApplications={checkApplications}
        />
        <Query
          query={PRODUCTS_QUERY}
          variables={{
            page: this.props.page,
            pageSize: this.state.pageSize,
            params: this.state.searchParams,
          }}
          fetchPolicy="network-only"
        >
          {({ loading, error, data }) => {
            if (loading) {
              return (
                <div className="product-list" style={{ width: '100%', textAlign: 'center', marginTop: 20 }}>
                  <PulseLoader loading={loading} color="#004DA9" sizeUnit="px" size={15} />
                </div>
              );
            }
            if (error) {
              console.log(error);
              return (
                <div className="product-list" style={{ width: '100%', textAlign: 'center', marginTop: 20 }}>
                  <div>There is a server error, please contact the administrator!</div>
                </div>
              );
            }
            if (data.getItems.items.length === 0) {
              return (
                <div className="product-list" style={{ width: '100%', textAlign: 'center', marginTop: 20 }}>
                  <div>There are no results!</div>
                </div>
              );
            }
            return (
              <div className="product-list">
                <ul className="products">
                  { data.getItems.items.map((product) => {
                    return (
                      <ProductCard
                        product={product}
                        favouriteItem={this.favouriteItem}
                        key={product.id}
                        updateBrand={this.props.updateBrand}
                      />
                    );
                  })}
                </ul>
                {data.getItems.pages > 1 && <Pagination page={data.getItems.page || 0} pages={data.getItems.pages} updatePage={this.props.updatePage} />}
              </div>
            );
          }}
        </Query>
      </div>
    );
  }
}

Products.propTypes = {
  applications: PropTypes.array,
  brands: PropTypes.array,
  updateBrand: PropTypes.func.isRequired,
  updateApplication: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  updatePage: PropTypes.func.isRequired,
};

export default withRouter(Products);



// WEBPACK FOOTER //
// ./src/components/Products/products.js